import { FontsWeights, dimensions } from '@factorialco/deprecated-design-system'

export const STICKY_CELL_WIDTH = dimensions.s300

export const WEIGHT: Record<number, FontsWeights> = {
  0: 'semibold',
  1: 'medium',
  2: 'normal',
}
